import "./nsitf.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";

import rmaStart from "../images/rma-start.png";

import check from "../images/check.png";
import rmaStarted from "../images/rma-started.png";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Nsitf = () => {
  window.scrollTo(0, 0);

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [listSections, setListSections] = useState([]);
  const [businessSections, setBusinessSections] = useState([]);
  const [productInfo, setProductInfo] = useState([]);
  const [productText, setProductText] = useState("");
  const [productTextContd, setProductTextContd] = useState("");


                      useEffect( () => {
                                       AOS.init({
                                          offset: 0,
                                          duration: 1000,
                                          once: true
                                   });
                                                    
                                                        
                                   }, [])

  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages {
              edges {
                node {
                  nsitf {
                    hero {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    heromobile {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    listSection {
                      heading
                      explanation
                      image {
                        mediaItemUrl
                      }
                      list {
                        item
                      }
                    }
                    productText
                    productTextContd
                    productinfo {
                      heading
                      list {
                        item
                      }
                    }
                    section {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);

        setHeroBanner(result.data.pages.edges[1].node.nsitf.hero);
        setHeroMobile(result.data.pages.edges[1].node.nsitf.heromobile);
        setListSections(result.data.pages.edges[1].node.nsitf.listSection);
        setBusinessSections(result.data.pages.edges[1].node.nsitf.section);
        setProductInfo(result.data.pages.edges[1].node.nsitf.productinfo);
        setProductText(result.data.pages.edges[1].node.nsitf.productText);
        setProductTextContd(
          result.data.pages.edges[1].node.nsitf.productTextContd,
        );
      });
  }, []);

  let listSectionsDisplay;
  let heroBannerDisplay;
  let heroMobileBannerDisplay;
  let businessSectionsDisplay;
  let productInfoDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="mp-cover">
        <img className="mp-bg" src={banner.image.mediaItemUrl} />
        <div className="mp-content">
          <div className="mp-txt">
            <h1 className="mp-h1 " data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) => (
      <div className="mp-cover">
        <img className="mp-bg" src={banner.image.mediaItemUrl} />
        <div className="mp-content">
          <div className="mp-txt">
            <h1 className="mp-h1" data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (productInfo.length > 0) {
    productInfoDisplay = productInfo.map((info, i) => (
      <div className="card nsif-crd text-start">
        <h5 className="rma-hdr" data-aos="fade-up" data-aos-delay="200">{info.heading}</h5>
        <hr className="btm-bdr-ntsif" />

        <ul
          className="pt-1 icon-white custom-rma-ul"
          style={{
            listStyleType: "decimal-leading-zero",
            paddingLeft: "20px",
          }}
        >
          {info.list.map((items, i) => (
            <li
              id="nsif-li"
              className="grey-p-rma pt-3"
              style={{ color: "#bebebe", fontSize: "16px" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              <img className="rma-check" src={check} /> {items.item}
            </li>
          ))}
        </ul>
      </div>
    ));
  }

  if (listSections.length > 0) {
    listSectionsDisplay = listSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between pb-5 z-value"
        >
          <div className="d-flex justify-content-end">
            <img className="img-fluid-nsif" src={section.image.mediaItemUrl} />
          </div>

          <div className="nsif-div1 pb-5">
            <h3 className="nsif-h3 pb-2" data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>
            <p id="nsif-p" className="pt-3 pb-4 grey-p grey-color" data-aos="fade-up" data-aos-delay="200">
              {section.explanation}
            </p>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-4 custom-rma-ul"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li id="nsif-li" className=" pt-3" data-aos="fade-up" data-aos-delay="200">
                  <img className="rma-check" src={check} /> {items.item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between pb-5 z-value"
        >
          <div className="nsif-div1 pb-5">
            <h3 className="nsif-h3 pb-2" data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>
            <p id="nsif-p" className="pt-3 pb-4 grey-p grey-color" data-aos="fade-up" data-aos-delay="200">
              {section.explanation}
            </p>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-4 custom-rma-ul"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li id="nsif-li" className="pt-3" data-aos="fade-up" data-aos-delay="200">
                  <img className="rma-check" src={check} /> {items.item}
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid-nsif" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  if (businessSections.length > 0) {
    businessSectionsDisplay = businessSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="values-ntsif compact-section">
            <h3 className="mp-h3 mp-h3" data-aos="fade-up" data-aos-delay="200">{section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-acc-btn grey-p mt-3"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
            
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="mp-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="values-ntsif compact-section">
            <h3 className="mp-h3 mp-h3" data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-acc-btn grey-p mt-3"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="mp-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  return (
    <>
      <div className="rma-container d-none d-sm-block">{heroBannerDisplay}</div>

      <div className="rma-container d-block d-sm-none">
        {heroMobileBannerDisplay}
      </div>

      <div className="containeer">
        <div
          id="mobile-view"
          className="d-flex justify-space-between pt-5 padding-section-standard-bottom"
        >
          <div className=" width-fifty">
            <h2 className="rma-h2 pb-4"> What Is NSITF Transfer? </h2>
          </div>
          <div className=" width-fifty abt-para">
            <p id="nsif-p" className="grey-p grey-color">
              {productText}
            </p>

            <p id="nsif-p" className="grey-p grey-color">
              {productTextContd}
            </p>
          </div>
        </div>

        {listSectionsDisplay}
      </div>

      <div className="black-cont-rma">
        <div
          id="mobile-view"
          className="containeer  d-flex justify-content-between "
        >
          <div className="slider-divv-head-ntsif ">
            <p className="orange-p-rma pb-3">Required Documents</p>
            <h2 className="rma-h2 pb-2" style={{ color: "#FFFFFF" }}>
              NSITF Transfer Requirements
            </h2>
          </div>
          <div className="slider-divv-nsif">{productInfoDisplay}</div>
        </div>
        <div id="note-p">
          <p
            className="grey-p pt-4"
            style={{ color: "#bebebe", fontSize: "14px" }}
          >
            <span className="orange-p">Note:</span> If the employer still
            exists, the indemnity letter must be on official letterhead and
            stamped by a High Court.
          </p>
        </div>
      </div>

      <div className="containeer">{businessSectionsDisplay}</div>
         <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Nsitf;
